import { render, staticRenderFns } from "./BernoulliViz.vue?vue&type=template&id=cad42ede&scoped=true"
import script from "./BernoulliViz.vue?vue&type=script&lang=js"
export * from "./BernoulliViz.vue?vue&type=script&lang=js"
import style0 from "./BernoulliViz.vue?vue&type=style&index=0&id=cad42ede&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad42ede",
  null
  
)

export default component.exports